import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const TickerTape = ({ data, format }) => {
	const itemOne = data[0];
	const itemTwo = data[1];
	const tickerItemOne = (
		<div className='ticker-tape-item'>
			<img
				className={`emoji emoji-spin-${itemOne.emoji.spin}`}
				src={itemOne.emoji.image.url}
				alt={itemOne.emoji.image.alt}
			></img>
			<span className='h3 text'>{itemOne.text}</span>
		</div>
	);
	const tickerItemTwo = (
		<div className='ticker-tape-item'>
			<img
				className={`emoji emoji-spin-${itemTwo.emoji.spin}`}
				src={itemTwo.emoji.image.url}
				alt={itemTwo.emoji.image.alt}
			></img>
			<span className='h3 text'>{itemTwo.text}</span>
		</div>
	);
	const firstItems = [];
	const secondItems = [];

	const ticker = useRef(null);
	const tickerTop = useRef(null);
	const tickerBottom = useRef(null);

	const animatePercentage = () => {
		gsap.set(ticker.current, { visibility: 'visible' });
		gsap.timeline({
			scrollTrigger: {
				trigger: ticker.current,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true,
				invalidateOnRefresh: true,
			},
		})
			.to(tickerTop.current, {
				transform: 'translateX(240px)',
				ease: 'none',
			})
			.to(
				tickerBottom.current,
				{
					transform: 'translateX(-240px)',
					ease: 'none',
				},
				0,
			); // Add a delay of 0 seconds to synchronize both animations
	};
	useEffect(() => {
		animatePercentage();
	}, []);
	if (format === 'one') {
		for (let i = 0; i < 1; i++) {
			firstItems.push(tickerItemOne);
			firstItems.push(tickerItemTwo);
			secondItems.push(tickerItemOne);
			secondItems.push(tickerItemTwo);
		}
		return (
			<div ref={ticker} className={`ticker-tape ticker-tape-${format}`}>
				<div className='ticker-tape-inner'>
					<div
						ref={tickerTop}
						className='ticker-tape-tape ticker-tape-tape-top'
					>
						<div className='ticker-tape-item-merge'>
							{firstItems}
						</div>
						<div className='ticker-tape-item-merge'>
							{firstItems}
						</div>
						<div className='ticker-tape-item-merge'>
							{firstItems}
						</div>
						<div className='ticker-tape-item-merge'>
							{firstItems}
						</div>
						<div className='ticker-tape-item-merge'>
							{firstItems}
						</div>
						<div className='ticker-tape-item-merge'>
							{firstItems}
						</div>
						<div className='ticker-tape-item-merge'>
							{firstItems}
						</div>
					</div>
					<div
						ref={tickerBottom}
						className='ticker-tape-tape ticker-tape-tape-bottom'
					>
						<div className='ticker-tape-item-merge'>
							{secondItems}
						</div>
						<div className='ticker-tape-item-merge'>
							{secondItems}
						</div>
						<div className='ticker-tape-item-merge'>
							{secondItems}
						</div>
						<div className='ticker-tape-item-merge'>
							{secondItems}
						</div>
						<div className='ticker-tape-item-merge'>
							{secondItems}
						</div>
						<div className='ticker-tape-item-merge'>
							{secondItems}
						</div>
						<div className='ticker-tape-item-merge'>
							{secondItems}
						</div>
					</div>
				</div>
			</div>
		);
	} else {
		for (let i = 0; i < 12; i++) {
			firstItems.push(tickerItemOne);
			secondItems.push(tickerItemTwo);
		}
		return (
			<div ref={ticker} className={`ticker-tape ticker-tape-${format}`}>
				<div className='ticker-tape-inner'>
					<div
						ref={tickerTop}
						className='ticker-tape-tape ticker-tape-tape-top'
					>
						{firstItems}
					</div>
					<div
						ref={tickerBottom}
						className='ticker-tape-tape ticker-tape-tape-bottom'
					>
						{secondItems}
					</div>
				</div>
			</div>
		);
	}
};
export default TickerTape;
